import { gql } from "@apollo/client";

export const AddSwConfigVariables = gql`
  mutation AddSwConfigVariables(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $input: SwConfigVarInput!
  ) {
    AddSwConfigVariables(
      token: $token
      user_details: $user_details
      customerID: $customerID
      input: $input
    )
  }
`;

export const UpdateSwConfigVariables = gql`
  mutation UpdateSwConfigVariables(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $input: [UpdateSwConfigVariables!]!

  ) {
    UpdateSwConfigVariables(
      token: $token
      customerID:$customerID
      user_details: $user_details
      input: $input
     
    )
  }
`;
